var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fshr-gridItem",class:[
    _vm.xxs && ("fshr-gridItem--xxs-" + _vm.xxs),
    // xs && `fshr-gridItem--xs-${xs}`,
    _vm.sm && ("fshr-gridItem--sm-" + _vm.sm),
    _vm.md && ("fshr-gridItem--md-" + _vm.md),
    // lg && `fshr-gridItem--lg-${lg}`,
    _vm.xl && ("fshr-gridItem--xl-" + _vm.xl) ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }